/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsCustomUnderUtilizedResource extends models.RecommendationBaseForFinopsCustomResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsCustomUnderUtilizedResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsCustomUnderUtilizedResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsCustomUnderUtilizedResource>): RecommendationForFinopsCustomUnderUtilizedResource {
        let obj = Object.assign(new RecommendationForFinopsCustomUnderUtilizedResource(), model);
        RecommendationForFinopsCustomUnderUtilizedResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsCustomUnderUtilizedResource>): RecommendationForFinopsCustomUnderUtilizedResource {
        if (!model) return null;
        return RecommendationForFinopsCustomUnderUtilizedResource.newInstance(<RecommendationForFinopsCustomUnderUtilizedResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsCustomUnderUtilizedResource) {
        if (!obj) return;

        models.RecommendationForFinopsCustomUnderUtilizedResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsCustomUnderUtilizedResource): boolean {
        if (models.RecommendationBaseForFinopsCustomResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsCustomUnderUtilizedResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
